if(!customElements.get('facets-view')) {
  customElements.define('facets-view',
    class  facetsView extends HTMLElement {
      constructor() {
        super();
        this.items = this.querySelectorAll('.facets-view-item');
        this.gridLayoutMobileDefault  = this.dataset.itemMobile;;
        this.gridLayoutDesktopDefault  = this.dataset.itemDesktop;

        this.init();
      }

      init() {
        let self = this;
        this.items.forEach(item => {
          item.addEventListener('click', function(event) {
            self.changeViewLayout(event.currentTarget);
          })
        });

      }

      changeViewLayout(clickedItem) {
        let positionShow = clickedItem.dataset.positionShow;
        let layout =document.getElementById('ProductGridContainer');
        let gridLayout = clickedItem.dataset.gridLayout;
        let layoutMobileNow = layout.dataset.gridMobile;
        
        let layoutDesktopNow = layout.dataset.gridDesktop;

        if(positionShow === 'mobile') {
          layout.dataset.gridMobile = gridLayout;

          layout.classList.remove(`f-grid-${layoutMobileNow}-cols`);
          layout.classList.add(`f-grid-${gridLayout}-cols`);
        } else {
          layout.dataset.gridDesktop = gridLayout;
          layout.classList.remove(`md:f-grid-${layoutDesktopNow}-cols`, `xl:f-grid-${layoutDesktopNow}-cols`);
          layout.classList.add(`md:f-grid-${gridLayout}-cols`, `xl:f-grid-${gridLayout}-cols`);
        }

        let elParent = clickedItem.closest('.facets-view-items');
        elParent.querySelector('.facets-view-item.active')?.classList.remove('active');
        clickedItem.classList.add('active');

      }
    }
  )
}